class ShoppingCart {
  constructor() {
    this.cart = JSON.parse(localStorage.getItem('cart'));
    const isNotObj = typeof this.cart !== 'object';
    const isArray = Array.isArray(this.cart);
    const isValidCart = this.isValidCart();
    if (this.cart === null || isNotObj || isArray || !isValidCart) {
      localStorage.removeItem('cart');
      this.cart = {};
      localStorage.setItem('cart', JSON.stringify(this.cart));
    }
  }

  isValidCart() {
    try {
      const expectedSubKeys = ['description', 'pricePer', 'quantity'];
      let valid = true;
      Object.keys(this.cart).forEach((priceId) => {
        const item = this.cart[priceId];
        // These are the sub keys per item we expect
        if (Object.keys(item).length !== 3) {
          valid = false;
        }
        expectedSubKeys.forEach((ekey) => {
          if (!(ekey in item)) {
            valid = false;
          }
        });
      });
      return valid;
    } catch (error) {
      return false;
    }
  }

  saveCart() {
    localStorage.setItem('cart', JSON.stringify(this.cart));
  }

  emptyCart() {
    this.cart = {};
  }

  isEmpty() {
    return Object.keys(this.cart).length === 0;
  }

  setItem(priceId, quantity, pricePer, description) {
    if (!(priceId in this.cart)) {
      this.cart[priceId] = {};
    }
    if (quantity > 0) {
      this.cart[priceId].description = description;
      this.cart[priceId].quantity = quantity;
      this.cart[priceId].pricePer = pricePer;
    } else {
      delete this.cart[priceId];
    }
  }

  totalQuantity() {
    let q = 0;
    Object.keys(this.cart).forEach((key) => {
      q += parseInt(this.cart[key].quantity, 10);
    });
    return q;
  }

  totalPrice() {
    let p = 0.0;
    Object.keys(this.cart).forEach((key) => {
      p += parseFloat(this.cart[key].pricePer) * this.cart[key].quantity;
    });
    return p;
  }

  totalItems() {
    return Object.keys(this.cart).length;
  }

  getDict() {
    return this.cart;
  }
}

export default ShoppingCart;
